import { Directive, Input, TemplateRef, ViewContainerRef, effect, inject } from '@angular/core';
import { PrivilegeService } from '../../core/services/privileges/privilege.service';
import { AuthService } from '../../core/services/auth/auth.service';

@Directive({
  selector: '[appHasPrivilege]',
  standalone: true
})
export class HasPrivilegeDirective {
  private privilege: string | string[] = '';
  private isHidden = true;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private privilegeService: PrivilegeService,
    private authService: AuthService
  ) {
    // Reactively check permissions when user/privileges change
    effect(() => {
      // Accessing the signal registers this effect as a dependency
      this.authService.currentUser();
      this.updateView();
    });
  }

  @Input() set appHasPrivilege(val: string | string[]) {
    this.privilege = val;
    this.updateView();
  }

  private updateView() {
    let hasPermission = false;

    if (Array.isArray(this.privilege)) {
      hasPermission = this.privilegeService.hasAnyPrivilege(this.privilege);
    } else {
      hasPermission = this.privilegeService.hasPrivilege(this.privilege);
    }

    if (hasPermission && this.isHidden) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.isHidden = false;
    } else if (!hasPermission && !this.isHidden) {
      this.viewContainer.clear();
      this.isHidden = true;
    }
  }
}
